/**
 * Checks if the state can access the context switcher
 * Hide the context switcher in the following states:
 * Washington, Puerto Rico, and all of Canada
 * @param state of the company
 */
export default function canStateAccessContextSwitcher({ state = '' }: { state: string }) {
  const excludedStates = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'PR', 'QC', 'SK', 'WA', 'YT'];

  return !excludedStates.includes(state);
}
